module.exports = __webpack_public_path__ + "media/react/marketing/pages/home/act/sections/apps/assets/app_store_icon-961f7f2beed035c1451a8b1d49563fd0.svg";